import component from './Ad';
import container from './Ad.container';
export default container(component);
//# sourceMappingURL=index.js.map